import(/* webpackMode: "eager" */ "/tmpl-test/components/site-header.tsx")